module.exports = __webpack_public_path__ + "static/33-ca57d5789735ccf7c6748a4fa6744f60.png";